var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.57129 6.66675L12.5713 6.66675M12.5713 6.66675C12.5713 8.04746 13.6906 9.16675 15.0713 9.16675C16.452 9.16675 17.5713 8.04746 17.5713 6.66675C17.5713 5.28604 16.452 4.16675 15.0713 4.16675C13.6906 4.16675 12.5713 5.28604 12.5713 6.66675ZM7.57129 13.3334L17.5713 13.3334M7.57129 13.3334C7.57129 14.7141 6.452 15.8334 5.07129 15.8334C3.69058 15.8334 2.57129 14.7141 2.57129 13.3334C2.57129 11.9527 3.69058 10.8334 5.07129 10.8334C6.452 10.8334 7.57129 11.9527 7.57129 13.3334Z",
    stroke: "#374151",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.789b5ac370ebbe4c713917054456b459.svg";
export { ForwardRef as ReactComponent };